
import analytics from '@/mixins.js/analytics'

export default {
  mixins: [analytics],
  props: {
    showPhoneButton: { type: Boolean, default: false },
  },
  methods: {
    openChat () {
      this.trackEvent('Contact', 'Open chat')
      window.$chatwoot.toggle('open')
    }
  }
}
